import { render, staticRenderFns } from "./PlayerMonitorPlayerRemoveModal.vue?vue&type=template&id=28429ccb&scoped=true&"
import script from "./PlayerMonitorPlayerRemoveModal.vue?vue&type=script&lang=ts&"
export * from "./PlayerMonitorPlayerRemoveModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28429ccb",
  null
  
)

export default component.exports